<button
  class="user-popover-trigger"
  nz-popover
  nzPopoverTrigger="click"
  nzPopoverPlacement="rightBottom"
  nzPopoverOverlayClassName="user-popover-overlay"
  [nzPopoverContent]="popoverContent"
  [nzPopoverVisible]="visible()"
  (nzPopoverVisibleChange)="onVisibleChange($event)"
  [class.open]="visible()"
  [class.user-popover-trigger--compact]="compact()"
  [attr.aria-expanded]="visible()"
  [attr.aria-label]="'Abrir menu do usuário: ' + userName()"
  [attr.data-cy]="dataCy()">
  <lkt-avatar
    [src]="userAvatar()"
    [name]="userName()"
    [size]="avatarSize()"
    shape="circle"
    [alt]="userName()">
  </lkt-avatar>
  <span class="user-popover-trigger__name">{{ userName() }}</span>
</button>

<ng-template #popoverContent>
  <div class="user-popover" data-cy="user-popover-content">
    <span class="user-popover__greeting">Olá, {{ userName() }}!</span>

    <div class="user-popover__profile" data-cy="user-popover-profile">
      <span class="user-popover__profile-label">Perfil de</span>
      <lkt-chip-component
        [label]="profileLabel()"
        [icon]="profileIcon()"
        chipSize="compact"
        fontType="bold"
        [hasUserAction]="false">
      </lkt-chip-component>
      @if (hasMultipleProfiles()) {
        <button
          type="button"
          class="user-popover__switch-profile"
          (click)="onSwitchProfile()"
          (keydown.enter)="onSwitchProfile()"
          (keydown.space)="onSwitchProfile()"
          data-cy="user-popover-switch-profile">
          Trocar de Perfil
        </button>
      }
    </div>

    <div class="user-popover__list">
      @for (item of items(); track item.id) {
        <span
          class="user-popover__item-anchor"
          [nzTooltipTitle]="item.disabled ? (item.disabledReason ?? null) : null"
          nz-tooltip>
          <button
            type="button"
            class="user-popover__item"
            [class.user-popover__item--disabled]="item.disabled"
            [disabled]="item.disabled"
            [attr.aria-disabled]="item.disabled ? 'true' : null"
            (click)="onItemClick(item.id)"
            (keydown.enter)="onItemClick(item.id)"
            (keydown.space)="onItemClick(item.id)"
            [attr.data-cy]="'user-popover-item-' + item.id">
            <div class="user-popover__item-icon-wrapper">
              <i [class]="item.icon"></i>
            </div>
            <div class="user-popover__item-text">
              <span class="user-popover__item-title">{{ item.title }}</span>
              <span class="user-popover__item-description">{{ item.description }}</span>
            </div>
            @if (item.control === "toggle") {
              <span
                class="user-popover__toggle"
                [class.user-popover__toggle--on]="item.checked"
                role="switch"
                [attr.aria-checked]="item.checked ? 'true' : 'false'"
                [attr.data-cy]="'user-popover-toggle-' + item.id">
                <span class="user-popover__toggle-knob"></span>
              </span>
            } @else if (item.showArrow !== false) {
              <i class="uil uil-angle-right user-popover__item-arrow"></i>
            }
          </button>
        </span>
      }
    </div>

    <span class="user-popover__version" data-cy="user-popover-version">
      Lekto - Versão {{ version() }}
    </span>
  </div>
</ng-template>
